import { createContext, useContext, useState, useEffect } from 'react';

const MusicPlayerContext = createContext();

export const useMusicPlayer = () => {
  const context = useContext(MusicPlayerContext);
  if (!context) {
    throw new Error('useMusicPlayer must be used within a MusicPlayerProvider');
  }
  return context;
};

export const MusicPlayerProvider = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Load saved preferences
  useEffect(() => {
    const hidden = localStorage.getItem('rollm8s_music_hidden');
    if (hidden === 'true') {
      setIsVisible(false);
    }
  }, []);

  const showPlayer = () => {
    setIsVisible(true);
    localStorage.removeItem('rollm8s_music_hidden');
  };

  const hidePlayer = () => {
    setIsVisible(false);
    localStorage.setItem('rollm8s_music_hidden', 'true');
  };

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <MusicPlayerContext.Provider
      value={{
        isExpanded,
        setIsExpanded,
        isVisible,
        showPlayer,
        hidePlayer,
        toggleExpanded,
      }}
    >
      {children}
    </MusicPlayerContext.Provider>
  );
};

export default MusicPlayerContext;
